// extracted by mini-css-extract-plugin
module.exports = {"additionalTitle":"OnlinePortal_additionalTitle__1A7zn","wrapper":"OnlinePortal_wrapper__2_tU7"};